import Component from './business-info-page';
export default Component;
